<template>
  <div :class="['home', {'no-webp': !webp}]">
    <showreel></showreel>
    <services></services>
    <process></process>
    <technologies></technologies>
    <contact></contact>
  </div>
</template>

<script>

import Showreel from '../Showreel.vue'
import Services from '../Services.vue'
import Process from '../Process.vue'
import Technologies from '../Technologies.vue'
import Contact from '../Contact.vue'

export default {
  name: 'Home',
  components: {
    'showreel': Showreel,
    'services': Services,
    'process': Process,
    'technologies': Technologies,
    'contact': Contact
  },
  data() {
    return {
      webp: true
    }
  },
  mounted() {
    if (!this.canUseWebP()) {
      this.webp = false;
    }
  },
  methods: {
    canUseWebP() {
      var elem = document.createElement('canvas');

      if (!!(elem.getContext && elem.getContext('2d'))) {
          // was able or not to get WebP representation
          return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
      }

      // very old browser like IE 8, canvas not supported
      return false;
  }
  }
}
</script>
